import React from "react";
import Hero from "../sections/Hero";
import Manifesto from "../sections/Manifesto";
import ConsultationsPreview from "../sections/Services";
import Solutions from "../sections/Solutions";
import Process from "../sections/Process";
import Proof from "../sections/Proof";
import Contact from "../sections/Contact";

const Home = () => (
  <>
    <Hero />
    <Manifesto />
    <ConsultationsPreview />
    <Solutions />
    <Process />
    <Proof />
    <Contact />
  </>
);

export default Home;
